export const headerInfo = {
  "customContactNumber": "",
  "isSEWPUser": false,
  "isLoggedIn": false,
  "isIpsLogo": false,
  "locale": "en_US",
  "isAccountToolsEnabled": true,
  "isCreateAccountEnabled": true,
  "isLimitedBuyer": false,
  "isLiveChatEnabled": true,
  "isPhoneNumberEnabled": true,
  "region": "us",
  "userInformation": {
    "availableSites": [],
    "b2bInfo": {
      "isB2B": false
    },
    "permissions": {
      "enableSearch": true,
      "enableSearchSuggestions": true
    }
  },
  "isIPSUser": false
}
